module.exports = __webpack_public_path__ + "static/media/sierra.2b563090.png";